import{maxUint16}from"../../constants/number.js";export const maxBytecodeSize=32n*maxUint16;